require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-paul-conrad-featured-in-interview-with-indesignlive.json") })
        }
      }, "path---journal-paul-conrad-featured-in-interview-with-indesignlive");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-paul-conrad-featured-in-interview-with-indesignlive!./.cache/json/journal-paul-conrad-featured-in-interview-with-indesignlive.json
// module id = 520
// module chunks = 231608221292675